import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

const toastTypeVariations = {
  success: css`
    background: var(--principal-10);
    color: var(--principal-40);
  `,
  error: css`
    background: #fddede;
    color: #c53030;
  `,
}

export const Container = styled(animated.div)`
  display: flex;
  position: relative;
  background: #ebf8ff;
  color: #3172b7;
  width: 360px;
  padding: 16px 30px 16px 16px;
  border-radius: 8px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

  & + div {
    margin-top: 8px;
  }

  ${(props) => toastTypeVariations[props.type || '']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;
    font-size: 17px;
    line-height: 21px;
    
    p {
      margin-top: 4px;
      opacity: 0.8;
    }
  }

  button {
    position: absolute;
    right: 16px;
    top: 20px;
    opacity: 0.6;
    border: 0;
    background: transparent;
    color: inherit;
  }

  ${props => !props.hasDescription && css`
    align-items: center;

    svg {
      margin-top: 0;
    }
  `}
`;
